import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e23386"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row p-3 border-bottom" }
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "p-3" }
const _hoisted_11 = { class: "overflow-auto text-scroll fs-7 terms p-4 mx-3 mb-5 text-break break-spaces" }
const _hoisted_12 = { class: "text-center fw-bold mb-4 fs-7" }
const _hoisted_13 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_14 = {
  class: "modal fade",
  id: "finishModal",
  tabindex: "-1",
  "aria-labelledby": "finishModal",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header border-bottom-unset" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_18 = { class: "text-center py-3" }
const _hoisted_19 = { class: "d-flex justify-content-center modal-footer border-top-unset" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import communityAdminTermService from '@/services/community-admin-term.service'
import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { ALUMNI_REGISTER_FORM_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  terms: String,
  targetUser: String,
  targetUserOther: String,
  version: String,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()


const submitFailed = ref<boolean>(false)
const loadingBtn = ref<boolean>(false)
const SubmitTerm = async (): void => {
  loadingBtn.value = true
  try {
    const response = await communityAdminTermService.postTermApi(route?.params?.id, { user_type: route?.query?.tab || 'alumni', content: props.terms })
    if (response?.status === 200) {
      submitFailed.value = false
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
      store.dispatch(ALUMNI_REGISTER_FORM_STORE.ACTIONS.CHANGE_TERMS_OF_SERVICES, response?.data?.data)
    } else {
      submitFailed.value = true
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
    }
    // 2022/09/13 TienNV Fix double click button confirm edit CD40
    setTimeout(() => {
      loadingBtn.value = false
    }, 2000)
  } catch (error) {
    submitFailed.value = true
    loadingBtn.value = false
    modalConfirm.value?.hide()
    modalSuccess.value?.show()
  }
}

const modalSuccess = ref()
const modalConfirm = ref()
onMounted(() => {
  modalSuccess.value = new Modal(document.getElementById('finishModal'))
  modalConfirm.value = new Modal(document.getElementById('confirmModal'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "modal-content",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(translate)('CD40titleConfirm')), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translate)('CD40targetUser')), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(route)?.query?.tab === 'alumni' || _unref(route)?.query?.tab === '' ? _unref(translate)('almunai') : _unref(translate)('enroll')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, " Ver. " + _toDisplayString(__props.version ? __props.version + 1 : 1) + _toDisplayString(_unref(translate)('CD40contents')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.terms), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(translate)('CD40textConfirm')), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'me-2 fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: 'secondary',
                className: 'fw-bold',
                onClick: SubmitTerm,
                loading: loadingBtn.value,
                disabled: loadingBtn.value
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_18, _toDisplayString(submitFailed.value ? _unref(translate)('CD40notUpdated') : _unref(translate)('CD42UpdateSuccess')), 1),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})